import { capitalize } from "lodash-es";

export const splitPath = (path: string) => {
  const match = path.split(/(?=[A-Z])/);
  return match.map(val => capitalize(val)).join(" ");
};
